import React from 'react';

import Swiper from '@components/Swiper';
import MenuShimmerCard from './MenuShimmerCard';

function MenuShimmer() {
  return (
    <div className="full_width">
      <Swiper id="menu-shimmer">
        <MenuShimmerCard />
        <MenuShimmerCard />
        <MenuShimmerCard />
      </Swiper>
    </div>
  );
}

export default MenuShimmer;
